window.treatmentConfig = [
  {
    name: "Stingers Treatment",
    sessionTypeId: 13,
    price: "DROP-IN $12* | MEMBER $10*",
    note: "*PER UNIT",
    link: "/pages/stingers",
  },
  {
    name: "Stingers Consultation",
    sessionTypeId: 24,
    price: "",
    link: "/pages/stingers",
  },
  {
    name: "Fig Shot",
    sessionTypeId: 4073,
    price: "DROP-IN $35 | MEMBER $30",
    link: "/pages/fig-shot",
  },
  {
    name: "Rejuvenate + Plump Treatment (Dermal Fillers)",
    sessionTypeId: 4092,
    price: "DROP-IN FROM $450 | MEMBER FROM $405",
    link: "/pages/fillers",
  },
  {
    name: "Rejuvenate + Plump Consultation (Dermal Fillers)",
    sessionTypeId: 4093,
    price: "",
    link: "/pages/fillers",
  },
  {
    name: "Radiance + Renewal Laser Facial",
    sessionTypeId: 4074,
    price: "DROP-IN $325 | MEMBER $295",
    link: "/pages/radiance-renewal",
  },
  {
    name: "Light Therapy Boost Self-Serve Facial",
    sessionTypeId: 2051,
    price: "DROP-IN $30 | MEMBER $25",
    link: "/pages/light-therapy-boost",
  },
  {
    name: "Pregnancy Core Facial",
    sessionTypeId: 2046,
    price: "DROP-IN $99 | MEMBER $95",
    link: "/pages/pregnancy-facial",
  },
   {
    name: "All-In Intro Facial (New Guests)",
    sessionTypeId: 4109,
    price: "DROP-IN $99 | MEMBER $95",
    link: "/pages/pregnancy-facial",
  },
  {
    name: "Collagen + Texture Supers Facial",
    sessionTypeId: 2042,
    price: "DROP-IN $205 | MEMBER $185",
    link: "/pages/collagen-texture",
  },
  {
    name: "$125 Collagen + Texture Promo",
    sessionTypeId: 4110,
    price: "DROP-IN $125",
    link: "/pages/collagen-texture",
  },                    
  {
    name: "All-In Supers Facial",
    sessionTypeId: 2041,
    price: "DROP-IN $185 | MEMBER $165",
    link: "/pages/all-in",
  },
  {
    name: "Hydrate + Glow Core Facial",
    sessionTypeId: 14,
    price: "DROP-IN $99 | MEMBER $95",
    link: "/pages/hydrate-glow",
  },
  {
    name: "LED + Lymphatic Core Facial",
    sessionTypeId: 12,
    price: "DROP-IN $79 | MEMBER $75",
    link: "/pages/led-lymphatic",
  },
  {
    name: "Lift + Tone Core Facial",
    sessionTypeId: 10,
    price: "DROP-IN $125 | MEMBER $115",
    link: "/pages/lift-tone",
  },
  // TORONTO
  {
    name: "Stingers Follow Up",
    sessionTypeId: 27,
    price: "DROP-IN $12 | MEMBER $10",
    link: "/pages/stingers",
  },
  {
    name: "Stingers Treatment",
    sessionTypeId: 17,
    price: "DROP-IN $12* | MEMBER $10*",
    note: "*PER UNIT",
    link: "/pages/stingers",
  },
  {
    name: "Stingers Consultation",
    sessionTypeId: 18,
    price: "",
    link: "/pages/stingers",
  },
  {
    name: "Fig Shot",
    sessionTypeId: 20,
    price: "DROP-IN $35 | MEMBER $30",
    link: "/pages/fig-shot",
  },
  {
    name: "Rejuvenate + Plump Treatment (Dermal Fillers)",
    sessionTypeId: 30,
    price: "DROP-IN FROM $450 | MEMBER FROM $405",
    link: "/pages/fillers",
  },
  {
    name: "Rejuvenate + Plump Consultation (Dermal Fillers)",
    sessionTypeId: 31,
    price: "",
    link: "/pages/fillers",
  },
  {
    name: "Radiance + Renewal Laser Facial",
    sessionTypeId: 15,
    price: "DROP-IN $325 | MEMBER $295",
    link: "/pages/radiance-renewal",
  },
  {
    name: "Light Therapy Boost Self-Serve Facial",
    sessionTypeId: 22,
    price: "DROP-IN $30 | MEMBER $25",
    link: "/pages/light-therapy-boost",
  },
  {
    name: "Pregnancy Core Facial",
    sessionTypeId: 14,
    price: "DROP-IN $99 | MEMBER $95",
    link: "/pages/pregnancy-facial",
  },
  {
    name: "Collagen + Texture Supers Facial",
    sessionTypeId: 13,
    price: "DROP-IN $205 | MEMBER $185",
    link: "/pages/collagen-texture",
  },
  {
    name: "All-In Supers Facial",
    sessionTypeId: 12,
    price: "DROP-IN $185 | MEMBER $165",
    link: "/pages/all-in",
  },
  {
    name: "Hydrate + Glow Core Facial",
    sessionTypeId: 9,
    price: "DROP-IN $99 | MEMBER $95",
    link: "/pages/hydrate-glow",
  },
  {
    name: "LED + Lymphatic Core Facial",
    sessionTypeId: 8,
    price: "DROP-IN $79 | MEMBER $75",
    link: "/pages/led-lymphatic",
  },
  {
    name: "Lift + Tone Core Facial",
    sessionTypeId: 7,
    price: "DROP-IN $125 | MEMBER $115",
    link: "/pages/lift-tone",
  },
];

window.SITE_COUNTRY = {
  "493689": "CA", // Vancouver
  "5726529": "CA", // Toronto
  "5729211": "US", // Los Angeles
};